import { gql } from "@apollo/client";

// Query to get the weather station status
export const GET_ETD_STATUS = (
    etd_id: number, 
    page: number = 1, 
    pageSize: number = 10, 
    order_by: string = "asc"
) => gql`
    query MyQuery {
        its_etd_statuses_aggregate(
            where: {
                etd_id: {_eq: ${etd_id}}
            }
        ) {
            aggregate {
                count
            }
        }
        its_etd_statuses(
            where: {
                etd_id: {_eq: ${etd_id}}
            }, 
            order_by: {id: ${order_by}},
            limit: ${pageSize},
            offset: ${(page - 1) * pageSize}
        ) {
            id
            No_detector: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            Estado: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            Congestion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            Sent_contrario: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            Sent_circulacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            Longitud: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            Distancia: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            Intensidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Ocupacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Error_relativo: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_4: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`;